import type ChatInput from '@components/chat/input';
import callbackify from '@helpers/callbackify';
import AutocompletePeerHelper from '@components/chat/autocompletePeerHelper';
import processPeerFullForCommands from '@components/chat/processPeerFullForCommands';
import {AppManagers} from '@lib/managers';
import {Middleware} from '@helpers/middleware';

const CLASS_NAME = 'bot-commands';
export default class ChatBotCommands extends AutocompletePeerHelper {
  private userId: UserId;

  constructor(
    appendTo: HTMLElement,
    chatInput: ChatInput,
    private managers: AppManagers
  ) {
    super(appendTo, undefined, CLASS_NAME, (target) => {
      const text = target.querySelector(`.${AutocompletePeerHelper.BASE_CLASS_LIST_ELEMENT}-name`).textContent;
      return chatInput.getReadyToSend(() => {
        chatInput.messageInputField.setValueSilently(text);
        chatInput.sendMessage(true);
        this.toggle(true);
      });
    }, 'Chat.BotCommands');
  }

  public setUserId(userId: UserId, middleware: Middleware) {
    if(this.userId === userId && this.list?.childElementCount) {
      this.toggle(false);
      return;
    }

    this.userId = userId;
    return callbackify(this.managers.appProfileManager.getProfile(userId), (full) => {
      if(!middleware()) return;
      const filtered = processPeerFullForCommands(userId.toPeerId(false), full);

      const PADDING_TOP = 8;
      // const PADDING_BOTTOM = 8;
      const PADDING_BOTTOM = 24;
      const height = filtered.length * 50 + PADDING_TOP + PADDING_BOTTOM;
      this.container.style.setProperty('--height', height + 'px');

      this.render(filtered, middleware);

      // this.container.style.top =
    });
  }
}
